export default "__VITE_ASSET__CEA5AcAX__"